<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { Incident } from "@entity/Incident";
import RichText from "@component/RichText.vue";

defineOptions({
  inheritAttrs: false,
});

interface Props {
  incident: Incident;
}

const props = defineProps<Props>();
const { t } = useI18n();

function formatDate(date: string): string {
  const parsed = new Date(`${date.substring(0, 19)}+00:00`);
  const options: Intl.DateTimeFormatOptions = {
    month: "long",
    day: "numeric",
    year: "numeric",
  };

  return parsed.toLocaleDateString("en-US", options);
}

function formatTime(date: string): string {
  const parsed = new Date(`${date.substring(0, 19)}+00:00`);
  const options: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZoneName: "short",
  };

  return new Intl.DateTimeFormat("en-US", options).format(parsed);
}
</script>

<template>
  <div class="warning-description">
    <div class="left-description">
      <h2>{{ props.incident.alert.description }}</h2>
    </div>
    <div class="right-description-block">
      <h2 class="right-title">{{ t("service.status.update") }}</h2>
      <div class="right-description">
        <p v-for="statusUpdate in props.incident.alert.statusUpdates" :key="statusUpdate.date" class="flex space-between">
          <span>
            <b>{{ formatDate(statusUpdate.date) }}</b>
            <br>
            {{ formatTime(statusUpdate.date) }}
          </span>
          <RichText as="span" :html="statusUpdate.message" />
        </p>
      </div>
    </div>
  </div>
</template>
